module.exports = __webpack_public_path__ + "img/pwd.0422e9e3.png";